// WorkingProcess.tsx
import React, { useRef, useEffect } from 'react';
import { Box, Typography, Grid, Paper, Container } from '@mui/material';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SmoothWaveText from '../../Components/SmoothWaveText';

gsap.registerPlugin(ScrollTrigger);

const steps = [
  {
    id: '01',
    title: 'Strategic & High-Performance Real Estate Coaching',
    description:
      'As a Real Estate Sales Coach, I help agents and teams build the skills they need to grow faster and close more deals.Through my structured real estate coaching programs, I guide you to strengthen your sales approach, improve client communication, and create predictable revenue.My coaching is designed to help you position yourself as a trusted real estate professional, use behavioural sales techniques effectively, and achieve consistent results in any market.',
  },
  {
    id: '02',
    title: 'Real Estate Sales Coaching for High-Ticket & Luxury Closings',
    description:
      'I specialise in helping real estate agents master high-ticket and luxury real estate sales.With 15+ years of hands-on experience as a RERA-registered Realtor and active member of NAR/HRA, I teach practical strategies in sales psychology, negotiation, follow-up systems, and premium client handling.My real estate sales coaching is built for professionals who want to close ₹Cr+ deals, improve conversion rates, and deliver a high-quality experience that attracts serious buyers.',
  },
  // {
  //   id: '03',
  //   title: 'Strategic and Powerful Branding  ',
  //   description:
  //     'Command attention with strategic branding. Define your edge, craft a premium story, and magnetize high-net-worth clients. Elevate trust and dominate the luxury real estate market.',
  // },
];

const WorkingProcess: React.FC = () => {
  const cardsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    cardsRef.current.forEach((el, index) => {
      if (el) {
        gsap.fromTo(
          el,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              toggleActions: 'play none none reverse',
            },
            delay: index * 0.2,
          }
        );
      }
    });
  }, []);

  return (
    <Box sx={{ bgcolor: '#f7f5f0', borderTop: '1px solid #0f63a5', borderBottom: '1px solid #ccc', color: 'primary.main', py: 4,
     height: {xs:'auto',md:'auto'} }}>
      <Container maxWidth='xl'>

        <Grid container alignItems="start" sx={{
          mb: 6,
          // borderTop: '1px solid #0f63a5',
          py: 4
        }}>
          <Grid item xs={12} md={3} sx={{}}>
            <SmoothWaveText variant="subtitle2"
              sx={{
                textTransform: 'uppercase',
                color: '#0f63a5',
                fontSize: '14px',
              }}>
                // WORKING PROCESS
            </SmoothWaveText>
          </Grid>
          <Grid item xs={12} md={7} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography variant='h6' sx={{ fontSize: 18, textAlign: 'center', color: 'black', }}>
              Over a decade of experience in interactive design and working with some of the most talented people in the business
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={4} justifyContent="center">
          {steps.map((step, i) => (
            <Grid item xs={12} md={5.5} key={step.id} sx={{mb:{xs:6,md:0}}}>
              <Paper
                elevation={0}
                sx={{
                  height: {xs:'auto',md:'390px'},
                  p: 4,
                  backgroundColor: 'transparent',
                  border: '1px dashed #0f63a5',
                  borderRadius: 2,
                  color: '#000',
                  textAlign: 'start',
                }}
                // ref={(el: HTMLDivElement | null) => {
                //   cardsRef.current[i] = el;
                // }}
              >
                <Typography variant='h6' sx={{ color: '#0f63a5', mb: 1, fontWeight: 700, }}>//{step.id}</Typography>
                <Typography variant="h3" sx={{ fontWeight: 700, color: '#0f63a5', mb: 2 }}>
                  {step.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#000', }}>{step.description}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

    </Box>
  );
};

export default WorkingProcess;
